import { useEffect, useState } from "react";
import image8 from "assets/hm_service_image/MHSD_footer.png";
import image9 from "assets/hm_service_image/MHSDmb.png";
import image10 from "assets/hm_service_image/footer-introduce-step.png";
import { confirmWaitOrderSD, getDetailPreOrderHashcode, getStatusPreorderSD } from "services/pre-order.service";
import { PRODUCTS } from "config/products";
import HomeBannerPromotion from "components/shared/HomeBannerPromotion";
import { HomeStyled } from "styles/homeStyled";
import { notification, Modal } from "antd";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CheckCircleFilled } from "@ant-design/icons";
// import homebn from "assets/hm_service_image/bn-doi.png";

function WaitingProduct() {
    const [loading, setLoading] = useState(true);
    const [preOrder, setPreOrder] = useState({});
    const { pre_order_id } = useParams();
    const [statusPreOrder, setStatusPreOrder] = useState(null);
    useEffect(() => {
        const getData = async () => {
            const res = await getDetailPreOrderHashcode(pre_order_id);
            if (!res?.data) return res;

            let product = PRODUCTS.find((x) => +x.productId === +res.data.PRODUCTID);

            if (product) {
                res.data.productSelect = {
                    ...product,
                    // capacityName: CAPACITYS.find((x) => x.capacityKey === product.capacityKey)?.name,
                    // colorName: COLORS.find((x) => x.colorKey === product.colorKey)?.colorName,
                };
            }
            return res;
        };

        const loadPreOrder = async () => {
            setLoading(true);
            try {
                const res = await getData();
                if (!res?.data) return;
                setPreOrder(res.data);
                if (res.data?.ORDERNO) {
                    const result = await getStatusPreorderSD(res.data.ORDERNO);
                    if (result) setStatusPreOrder(result?.data);
                }
                setLoading(false);
            } catch (error) {
                notification.error({
                    message: error?.message ?? "Không có dữ liệu đơn hàng",
                });
            } finally {
                setLoading(false);
            }
        };
        loadPreOrder();
    }, [pre_order_id]);

    const [confirming, setConfirming] = useState(false);

    const handleConfirmWait = async () => {
        if (!preOrder?.ORDERNO) {
            notification.error({ message: "Không tìm thấy mã đơn hàng" });
            return;
        }

        setConfirming(true);
        try {
            const res = await confirmWaitOrderSD(preOrder?.ORDERNO);
            setStatusPreOrder((prev) => ({
                ...prev,
                isConfirmedWait: true
            }));

            if (res?.success) {
                Modal.success({
                    icon: null,
                    title: (
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <CheckCircleFilled style={{ color: "#52c41a", fontSize: 20 }} />
                            <span>Xác nhận chờ thành công</span>
                        </div>
                    ),
                    content: (
                        <div>
                            <p style={{ marginBottom: 8 }}>
                                Cảm ơn quý khách đã xác nhận chờ. Chúng tôi sẽ gửi phiếu xác nhận qua thông tin liên hệ của bạn.
                            </p>
                            {/* <p>
                                Thời gian dự kiến trả hàng tiếp theo: <strong>10/10/2026</strong>
                            </p> */}
                        </div>
                    ),
                    centered: true,
                    okText: "Đóng"
                });
            } else {
                notification.error({ message: res?.message || "Xác nhận thất bại!" });
            }
        } catch (error) {
            notification.error({ message: "Có lỗi xảy ra khi xác nhận!" });
        } finally {
            setConfirming(false);
        }
    };

    const createdDate = new Date(preOrder?.CREATEDDATE);
    const startOfSep2026 = new Date('2026-08-01T00:00:00');

    const isBeforeSep2026 = createdDate < startOfSep2026;

    return (
        <HomeStyled>
            <div className="pre-order-page">
                <div className="page pre-home-page">
                    <div className="home-banner home-banner-rp">
                        <div className="content-home-banner bn-big">
                            {/* <img src={homebn} alt="" width="100%" className="" /> */}
                            {/* <img src={homebnmb} alt="" width="100%" className="f-mb" /> */}
                            <HomeBannerPromotion />
                        </div>
                    </div>

                    {!isBeforeSep2026 &&
                        <div className="container-ordercomplete">
                            {!loading
                                && statusPreOrder?.isAssignedToBatch === false
                                && statusPreOrder?.isRefunded === false
                                && statusPreOrder?.isReplaced === false
                                && statusPreOrder?.isPaid === true
                                && statusPreOrder?.isDelivered === false
                                && (
                                    <div className="confirm-watiting">
                                        {statusPreOrder?.isConfirmedWait ? (
                                            <div style={{ textAlign: 'center' }}>
                                                <p style={{ color: 'white' }}>
                                                    Cảm ơn quý khách đã xác nhận chờ. Chúng tôi sẽ gửi phiếu xác nhận qua thông tin liên hệ của bạn.
                                                </p>
                                                {/* <p style={{ color: 'white' }}>
                                                    Thời gian dự kiến trả hàng tiếp theo: <strong>10/10/2026</strong>
                                                </p> */}
                                            </div>
                                        ) : (
                                            <div className="btn-confirm-watiting">
                                                <a className="btn-stutus" onClick={handleConfirmWait}>
                                                    {confirming ? "Đang xác nhận..." : "Xác nhận"}
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                )}
                        </div>
                    }

                    <div className="footer-introduce desktop">
                        <img src={image8} alt="" width="100%" />
                    </div>

                    <div className="footer-introduce mobile">
                        <h3 className="tt-introduce">Tại sao nên mua hàng tại ShopDunk</h3>
                        <div className="d-scroll">
                            <img src={image9} alt="" width="1328px" />
                        </div>
                        {/* <h3 className="tt-introduce">Cách sở hữu iPhone 16 Pro Max sớm nhất, giá tốt nhất</h3>
                        <div className="d-scroll">
                            <img src={image10} alt="" width="1032px" />
                        </div> */}
                    </div>
                </div>
            </div>
        </HomeStyled>
    );
}

export default WaitingProduct;
